export const enum ESlotStatus {
  LESS_THIRD = 'LESS_THIRD',
  MORE_THIRD = 'MORE_THIRD',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  OVERLOADED = 'OVERLOADED',
  BOOKED_WHILE_CLOSED = 'BOOKED_WHILE_CLOSED',
  CLOSED = 'CLOSED'
}
